(() => {
  const initializedSections = new WeakSet();
  const mobileMedia = window.matchMedia('(max-width: 989px)');

  const setupFilterSeals = (section) => {
    if (initializedSections.has(section)) return;

    const slider = section.querySelector('.filter-seals__list');
    const slides = Array.from(section.querySelectorAll('.filter-seals__slide'));
    const dots = Array.from(section.querySelectorAll('[data-filter-seals-page]'));
    const arrows = Array.from(section.querySelectorAll('.filter-seals__arrow'));

    if (!slider || !slides.length || !dots.length) return;
    initializedSections.add(section);

    const pagePositions = () => dots.map((_, index) => slides[index * 2]?.offsetLeft || 0);

    const setActivePage = (activeIndex) => {
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.toggleAttribute('aria-current', active);
      });
    };

    const updatePagination = () => {
      if (!mobileMedia.matches) return;

      const positions = pagePositions();
      const activeIndex = positions.reduce((closestIndex, position, index) => {
        return Math.abs(position - slider.scrollLeft) < Math.abs(positions[closestIndex] - slider.scrollLeft)
          ? index
          : closestIndex;
      }, 0);

      setActivePage(activeIndex);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slider.scrollTo({ left: pagePositions()[index], behavior: 'smooth' });
        setActivePage(index);
      });
    });

    let animationFrame;
    slider.addEventListener('scroll', () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(updatePagination);
    });

    const updateArrowStep = () => {
      arrows.forEach((arrow) => {
        arrow.dataset.step = mobileMedia.matches ? '2' : '1';
      });
      updatePagination();
    };

    mobileMedia.addEventListener('change', updateArrowStep);
    window.addEventListener('resize', updatePagination);
    updateArrowStep();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.filter-seals').forEach(setupFilterSeals);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
